import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=278b1bc4&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278b1bc4')) {
      api.createRecord('278b1bc4', component.options)
    } else {
      api.reload('278b1bc4', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=278b1bc4&", function () {
      api.rerender('278b1bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X6nim3Rxa1gq/JS/pricehelp.vue"
export default component.exports